import { RpcService } from 'rpc';
import { InfoRPC, QuizRPC, StartQuiz } from '../interfaces';

export interface IFlashcard extends RpcService {
	quiz(): Promise<QuizRPC>;
	info(): Promise<InfoRPC>;
	start_quiz(): Promise<StartQuiz>;
	continue_quiz(): Promise<StartQuiz>;
	restart_quiz(): Promise<StartQuiz>;
	finish_quiz(): Promise<any>;
	recommended_reading(): Promise<any>;
	reportlines(params: { name: any }): Promise<any>;
	update_results(params: { results: any[] }): Promise<any>;
	get_questions(params: { qrlocator: any; select: any }): Promise<any>;
}

export const svc: IFlashcard = new RpcService({
	transport: 'WEBSOCKET',
	envelope: 'JSON-RPC-2.0',
	strictParameters: false,
	target: `@@flashcard.rpc`,

	services: {
		quiz: {
			parameters: []
		},
		info: {
			parameters: []
		},
		start_quiz: {
			parameters: []
		},
		continue_quiz: {
			parameters: []
		},
		restart_quiz: {
			parameters: []
		},
		finish_quiz: {
			parameters: []
		},
		recommended_reading: {
			parameters: []
		},
		reportlines: {
			parameters: [
				{
					name: 'select',
					type: 'object',
					optional: true
				}
			]
		},
		update_results: {
			parameters: [
				{
					name: 'results',
					type: 'array',
					optional: false
				}
			]
		},
		get_questions: {
			parameters: [
				{
					name: 'qrlocator',
					type: 'object',
					optional: true
				},
				{
					name: 'select',
					type: 'object',
					optional: true
				}
			]
		}
	}
}) as IFlashcard;

export default svc;
